function EnergetickeStroje(){
    return(
    <div>
        Energeticke Stroje
    </div>
    );
};

export default EnergetickeStroje;